import { Form } from '@unform/web';
import styled from 'styled-components';

export const FormWrapper = styled(Form)`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 2.4rem;
  column-gap: 6.4rem;

  input[type='radio']:checked ~ span:after {
    transform: translate(-50%, -50%) scale(1);
  }

  textarea {
    font-family: 'Lato';
  }

  label {
    font-size: 1.5rem;
    font-weight: 500;
    opacity: 1;
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const InputBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > p {
    font-size: 1.4rem;
    opacity: 0.65;
    color: ${({ theme }) => theme.colors.black};
    user-select: none;
    padding: 0 0 0.6rem 1.2rem;
  }
`;
export const RadiosContainer = styled.div`
  display: flex;
  flex-direction: column;

  label {
    padding: 0 0 0.6rem 1.2rem;
  }
`;

export const Label = styled.div`
  padding: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0.6rem 1.2rem;

  svg {
    cursor: pointer;
  }
`;
